<template>
  <div class="format-box">
    <!-- 副标题 -->
    <div class="details-subTitle" v-if="item.type=='subTitle'">
      <span class="sub-title-icon"></span><div class="d-c-text">{{item.content}}</div>
    </div>
    <!-- 小标题 -->
    <div class="details-headline" v-if="item.type=='headline'" :class="{'details-headline-2':item.model==2}">
      <div class="d-c-text">{{item.content}}</div>
    </div>
    <!-- 文本内容 -->
    <div class="details-content" v-if="item.type=='content'" :class="{'details-content-2':item.model==2, 'details-content-3':item.model==3}">
      <div class="d-c-text" v-for="(info,idx) in item.list" :key="'con-'+idx">{{info}}</div>
    </div>
    <!-- 图片展示 -->
    <div class="details-images" :class="'details-img-'+item.imgType" v-if="item.type=='img'">
      <el-row type="flex" :gutter="item.gutter">
        <el-col class="img-col" :span="item.colSpan" v-for="(info,idx) in item.list" :key="'img-'+idx">
          <!-- <img :src="info" alt=""> -->
          <el-image class="det-img"
            :src="info"
            lazy
            :preview-src-list="item.list">
          </el-image>
        </el-col>
      </el-row>
    </div>
    <!-- 有序排列 -->
    <ul class="details-order" v-if="item.type=='order'" :class="{'details-order-2':item.model==2, 'details-order-3':item.model==3, 'details-order-4':item.model==4}">
      <li v-for="(info,idx) in item.list" :key="'order-'+idx">
        <div class="order-index" v-if="item.model != 4">{{info.index}}{{item.model==3?'、':''}}</div>
        <div class="order-index" v-else></div>
        <div class="order-content">
          <span class="order-c-title">{{info.title}}</span>
          <span class="order-c-c">{{info.content}}</span>
        </div>
      </li>
    </ul>
    <!-- 有序排列2 -->
    <ul class="details-order-t" v-if="item.type=='order2'" :class="{'details-order-t-2':item.model==2, 'details-order-t-3':item.model==3}">
      <li v-for="(info,idx) in item.list" :key="'order-'+idx">
        <div class="order-index" >{{info.index}}{{item.model==3?'、':''}} <span class="order-c-title">{{info.title}}</span></div>
        <div class="order-content">
          <div class="order-c-c"  v-for="(val,idx) in info.content" :key="'con2-'+idx">{{val}}</div>
        </div>
      </li>
    </ul>
    <!-- 无序排列 -->
    <div class="details-disorder" v-if="item.type=='disorder'" :class="{'details-disorder-2':item.model==2, 'details-disorder-3':item.model==3}">
      <ul>
        <li v-for="(info,idx) in item.list" :key="'disorder-'+idx">
          <span>{{info}}</span>
        </li>
      </ul>
    </div>
    <!-- row-col -->
    <el-row class="details-row-col details-disorder" v-if="item.type=='row-col'">
      <el-col :span="item.colSpan" v-for="(info,idx) in item.list" :key="'col-'+idx">
        <ul>
          <li class="dis-order-title">{{info.title}}</li>
          <li v-for="(val,key) in info.list" :key="'col-li-'+key">
            <span>{{val}}</span>
          </li>
        </ul>
      </el-col>
    </el-row>
    <!-- row-col -->
    <el-row class="details-card-row" :class="'d-c-row-'+item.model" v-if="item.type=='card-row'" type="flex" :gutter="item.gutter">
      <el-col :span="item.colSpan" :class="{'card-img-2':info.model== 2}" v-for="(info,idx) in item.list" :key="'col-'+idx">
        <el-card class="box-card" v-if="item.model=='card'">
          <div slot="header" class="card-title">
            <p v-for="(val, key) in info.title" :key="key">{{val}}</p>
          </div>
          <div >
            <el-image :src="info.img"></el-image>
            <div class="card-content" v-if="info.content && info.content.length>0">
              <p v-for="(val, key) in info.content" :key="key">{{val}}</p>
            </div>
          </div>
        </el-card>
        <div class="row-circle" v-if="item.model=='circle'">
          <img :src="info.img" alt="">
          <div class="circle-text">
            <p v-for="(val, key) in info.content" :key="key">{{val}}</p>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 轮播图 -->
    <div class="details-carousel" v-if="item.type=='carousel'">
      <el-carousel indicator-position="none" :interval="item.interval" :type="item.carouselType" :height="item.height">
        <el-carousel-item v-for="(info,idx) in item.list" :key="idx">
          <div class="carousel-card">
            <img :src="info.icon" alt="">
            <h3 class="medium">{{ info.title }}</h3>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
export default {
  props: ['item'],
  watch: {
    // item(n, o){
    //   console.log('222',n);
    // }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/details.scss';
</style>


// WEBPACK FOOTER //
// src/views/components/format.vue